import styled from 'styled-components'

export const ContestHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacings[6]};
  margin-bottom: ${({ theme }) => theme.spacings[4]};

  dl {
    flex: 1;
    display: grid;
    grid-template-rows: auto auto;
    grid-auto-flow: column;
    row-gap: ${({ theme }) => theme.spacings[1.5]};

    margin-bottom: ${({ theme }) => theme.spacings[4]};
  }
`

export const ModalHeaderContent = styled.div`
  display: block;
  width: 100%;

  h2 {
    margin-bottom: ${({ theme }) => theme.spacings[1]};
    text-align: center;
  }

  h4 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: ${({ theme }) => theme.spacings[4]};
    text-align: center;
  }
`

export const PaymentValuesContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-around;

  /* margin: ${({ theme }) => `${theme.spacings[12]} auto`}; */

  span {
    display: flex;
    flex-direction: column;

    div {
      h4 {
        margin-bottom: 0;
      }

      p {
        font-size: ${({ theme }) => theme.fontSizes.xmd};
        font-weight: bold;

        color: ${({ theme }) => theme.colors.pinkishGrey};
      }
    }

    div + div {
      margin-top: ${({ theme }) => theme.spacings[4]};
    }
  }

  span:last-of-type {
    align-items: center;
    justify-content: center;

    height: 110px;
    width: 220px;

    padding: ${({ theme }) => `0 ${theme.spacings[10]}`};

    border: 1px solid ${({ theme }) => theme.colors.primary};
    border-radius: 1.25rem;

    h4 {
      margin-bottom: ${({ theme }) => theme.spacings[2]};
    }

    p {
      font-size: ${({ theme }) => theme.fontSizes.lg};
      font-weight: bold;

      color: ${({ theme }) => theme.colors.primary};
    }
  }
`

type TabButtonProps = {
  active?: boolean
}

export const TabButton = styled.button<TabButtonProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacings[1.5]};

  min-width: 120px;

  font-weight: bold;

  padding: ${({ theme }) => `${theme.spacings[4]} ${theme.spacings[12]}`};

  color: ${({ theme, active }) =>
    active ? theme.colors.white : theme.colors.primary};

  border: ${({ theme }) => `1px solid ${theme.colors.primary}`};

  border-radius: 10px;

  background-color: ${({ theme, active }) =>
    active ? theme.colors.primary : 'transparent'};

  &:hover:not(:disabled) {
    opacity: 1;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
  }

  svg {
    width: ${({ theme }) => theme.fontSizes.md};
    height: ${({ theme }) => theme.fontSizes.md};

    color: inherit;
  }
`

export const BoletoDisclaimer = styled.span`
  display: block;

  width: fit-content;
  max-width: 80%;

  font-size: 20px;

  color: ${({ theme }) => theme.colors.warning};

  border: 1px solid ${({ theme }) => theme.colors.warning};
  border-radius: 10px;

  background-color: ${({ theme }) => theme.colors.warningLight};

  margin: ${({ theme }) => `${theme.spacings[8]} auto`};
  padding: ${({ theme }) => theme.spacings[4]}
    ${({ theme }) => theme.spacings[4]};
`

export const BoletoLink = styled.a`
  display: flex;
  justify-content: center;

  margin-top: 16px;

  font-size: ${({ theme }) => theme.fontSizes.xmd};

  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`
